
// import React from 'react';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import { withRouter } from 'react-router-dom';
// import UserLoginImg from '../../image/userLoginImg.jpg';
// import '../../css/loginformuser.css';
// import { useState } from 'react';
// import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
// import { getDatabase, ref, query, orderByChild, equalTo, get } from 'firebase/database';
// import { useHistory } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useAuth } from '../../../AuthContext';

// const LoginFormUser = ({ history }) => {
//     const { login } = useAuth();
//     const auth = getAuth();
//     const database = getDatabase();

//     const [user, setUser] = useState({
//         'loginId': '',
//         'Password': ''
//     });

//     const [loginMethod, setLoginMethod] = useState('mobile');
//     const [loading, setLoading] = useState(false);

//     const handleRegisterClick = () => {
//         history.push('/register');
//     }

//     const getData = (e) => {
//         const { value, name } = e.target;
//         setUser(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     }

//     const toggleLoginMethod = () => {
//         setLoginMethod(prev => prev === 'mobile' ? 'email' : 'mobile');
//         setUser(prev => ({ ...prev, loginId: '' }));
//     }

//     const addData = async (e) => {
//         e.preventDefault();
//         const { loginId, Password } = user;

//         // Validation
//         if (!loginId) {
//             toast.error(loginMethod === 'mobile' ? 'Mobile number is required' : 'Email is required');
//             return;
//         }
        
//         if (loginMethod === 'mobile') {
//             const phonePattern = /^\d{10}$/;
//             if (!phonePattern.test(loginId)) {
//                 toast.error('Please enter a valid 10-digit mobile number');
//                 return;
//             }
//         } else {
//             const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//             if (!emailPattern.test(loginId)) {
//                 toast.error('Please enter a valid email address');
//                 return;
//             }
//         }
        
//         if (!Password) {
//             toast.error('Password is required');
//             return;
//         }

//         setLoading(true);

//         try {
//             let emailToLogin = loginId;
//             let foundUserRole = '';
            
//             // If user entered mobile number, find the associated email
//             if (loginMethod === 'mobile') {
//                 const collections = ['users', 'doctor', 'hospitals'];
//                 let foundUserData = null;
//                 let foundUserId = null;
                
//                 for (const collection of collections) {
//                     const collectionRef = ref(database, collection);
//                     const queryRef = query(collectionRef, orderByChild('Mobile'), equalTo(loginId));
//                     const snapshot = await get(queryRef);

//                     if (snapshot.exists()) {
//                         const data = snapshot.val();
//                         foundUserId = Object.keys(data)[0];
//                         foundUserData = data[foundUserId];
                        
//                         if (foundUserData && foundUserData.Email) {
//                             emailToLogin = foundUserData.Email;
//                             foundUserRole = collection === 'users' ? 'patient' : 
//                                           collection === 'doctor' ? 'doctor' : 'hospital';
//                             break;
//                         }
//                     }
//                 }

//                 if (!foundUserData) {
//                     toast.error('No account found with this mobile number');
//                     setLoading(false);
//                     return;
//                 }
//             }

//             // Sign in with Firebase Authentication
//             const userCredential = await signInWithEmailAndPassword(auth, emailToLogin, Password);
//             const userId = userCredential.user.uid;
            
//             // Get user data from database
//             const collections = ['users', 'doctor', 'hospitals'];
//             let userData = null;
//             let userRole = '';
            
//             for (const collection of collections) {
//                 const userRef = ref(database, `${collection}/${userId}`);
//                 const snapshot = await get(userRef);
                
//                 if (snapshot.exists()) {
//                     userData = snapshot.val();
//                     userRole = collection === 'users' ? 'patient' : 
//                               collection === 'doctor' ? 'doctor' : 'hospital';
//                     break;
//                 }
//             }

//             if (userData) {
//                 // Prepare user name
//                 let userName = '';
//                 if (userRole === 'patient') {
//                     userName = `${userData.First || ''} ${userData.Last || ''}`.trim();
//                 } else if (userRole === 'doctor') {
//                     userName = `Dr. ${userData.First || ''} ${userData.Last || ''}`.trim();
//                 } else if (userRole === 'hospital') {
//                     userName = userData.HospitalName || 'Hospital User';
//                 } else {
//                     userName = userData.Email || 'User';
//                 }
                
//                 // Call login function with user data
//                 login(userId, userRole, userName, userData.Email || emailToLogin, userData.Mobile || '');
                
//                 toast.success(`Welcome back, ${userName}!`);
                
//                 // ✅ FIXED: Redirect based on role after 1.5 seconds
//                 setTimeout(() => {
//                     if (userRole === 'patient') {
//                         // Redirect to patient dashboard with their userId
//                         history.push(`/AppointmentCheck/${userId}`);
//                     } else if (userRole === 'doctor') {
//                         history.push("/");   // keep your existing doctor redirect
//                     } else if (userRole === 'hospital') {
//                         history.push("/");   // keep your existing hospital redirect
//                     } else {
//                         history.push("/");
//                     }
//                 }, 1500);
                
//             } else {
//                 toast.error('User data not found. Please contact support.');
//             }
            
//         } catch (error) {
//             console.error('Login error:', error);
            
//             if (error.code === 'auth/invalid-credential') {
//                 toast.error('Invalid credentials. Please check your login ID and password.');
//             } else if (error.code === 'auth/user-not-found') {
//                 toast.error('No account found. Please register first.');
//             } else if (error.code === 'auth/wrong-password') {
//                 toast.error('Incorrect password. Please try again.');
//             } else if (error.code === 'auth/too-many-requests') {
//                 toast.error('Too many failed attempts. Please try again later.');
//             } else if (error.code === 'auth/invalid-email') {
//                 toast.error('Invalid email format.');
//             } else {
//                 toast.error('Login failed: ' + error.message);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const forgotPasswordRedirect = () => {
//         history.push('/forgot-password');
//     }

//     return (
//         <div className='container-fluid'>
//             <ToastContainer />
//             <div className='row'>
//                 <div className='col-md-12 col-xl-6 col-xxl-6 col-sm-12'>
//                     <div className='container w-75 d-flex align-items-center justify-content-center'>
//                         <div className='text-primary'>
//                             <h2 className='text-center' style={{ marginTop: '10vh', textAlign: 'center' }}>
//                                 Welcome to TrustYou Doctor
//                             </h2>
//                             <p className='mt-0 pt-0 text-center ' color='#135078'>
//                                 Log in to manage appointments, access medical records, and stay connected with your healthcare journey.
//                             </p>
//                         </div>
//                     </div>
//                     <div className='d-flex align-items-center justify-content-center'>
//                         <Form style={{ width: '70%', padding: '3vh' }}>
//                             <div className="mb-3">
//                                 <div className="btn-group w-100" role="group">
//                                     <button
//                                         type="button"
//                                         className={`btn ${loginMethod === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`}
//                                         onClick={() => setLoginMethod('mobile')}
//                                     >
//                                         Mobile Login
//                                     </button>
//                                     <button
//                                         type="button"
//                                         className={`btn ${loginMethod === 'email' ? 'btn-primary' : 'btn-outline-primary'}`}
//                                         onClick={() => setLoginMethod('email')}
//                                     >
//                                         Email Login
//                                     </button>
//                                 </div>
//                             </div>
                            
//                             <Form.Group className="mb-3" controlId="formBasicLogin">
//                                 <Form.Label>
//                                     {loginMethod === 'mobile' ? 'Mobile Number' : 'Email Address'}
//                                 </Form.Label>
//                                 <Form.Control 
//                                     type={loginMethod === 'mobile' ? 'tel' : 'email'}
//                                     placeholder={
//                                         loginMethod === 'mobile' 
//                                         ? 'Enter 10-digit mobile number' 
//                                         : 'Enter your email address'
//                                     }
//                                     onChange={getData} 
//                                     name='loginId' 
//                                     value={user.loginId}
//                                     className="input-background-color" 
//                                     disabled={loading}
//                                 />
//                                 <Form.Text className="text-muted">
//                                     {loginMethod === 'mobile' 
//                                         ? 'Enter your registered mobile number' 
//                                         : 'Enter your registered email address'}
//                                 </Form.Text>
//                             </Form.Group>
                            
//                             <Form.Group className="mb-3" controlId="formBasicPassword">
//                                 <Form.Label>Password</Form.Label>
//                                 <Form.Control 
//                                     type="password" 
//                                     placeholder="Enter your password" 
//                                     onChange={getData} 
//                                     name='Password' 
//                                     value={user.Password}
//                                     className="input-background-color" 
//                                     disabled={loading}
//                                 />
//                             </Form.Group>
                            
//                             <Form.Group className="mb-3 text-end" controlId="formBasicCheckbox">
//                                 <Form.Label 
//                                     onClick={forgotPasswordRedirect} 
//                                     style={{ cursor: 'pointer', color: '#0d6efd' }}
//                                 >
//                                     Forgot Password?
//                                 </Form.Label>
//                             </Form.Group>
                            
//                             <div className="mb-3">
//                                 <Button 
//                                     className='btn btn-primary w-100' 
//                                     onClick={addData} 
//                                     variant="primary" 
//                                     type="submit"
//                                     disabled={loading}
//                                 >
//                                     {loading ? 'Logging in...' : 'Login'}
//                                 </Button>
//                             </div>
                            
//                             <div className="text-center">
//                                 <p className="mb-2">
//                                     {loginMethod === 'mobile' 
//                                         ? 'Prefer to login with email?' 
//                                         : 'Prefer to login with mobile?'}
//                                     <button 
//                                         type="button"
//                                         onClick={toggleLoginMethod}
//                                         style={{
//                                             border: 'none',
//                                             background: 'none',
//                                             color: '#2563EB',
//                                             marginLeft: '5px',
//                                             textDecoration: 'underline'
//                                         }}
//                                     >
//                                         Click here
//                                     </button>
//                                 </p>
                                
//                                 <button 
//                                     style={{ 
//                                         border: 'none', 
//                                         background: 'white', 
//                                         color: '#2563EB',
//                                         fontSize: '16px'
//                                     }} 
//                                     onClick={handleRegisterClick}
//                                 >
//                                     Don't have an Account? <strong>Register Now</strong>
//                                 </button>
//                             </div>
//                         </Form>
//                     </div>
//                 </div>
//                 <div className='col-md-12 col-xl-6 col-xxl-6 col-sm-12'>
//                     <img 
//                         src={UserLoginImg} 
//                         alt="User Login" 
//                         style={{ 
//                             maxWidth: '100%', 
//                             height: 'auto',
//                             objectFit: 'cover',
//                             minHeight: '100vh'
//                         }} 
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default withRouter(LoginFormUser);
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { withRouter } from 'react-router-dom';
import UserLoginImg from '../../image/userLoginImg.jpg';
import '../../css/loginformuser.css';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { getDatabase, ref, query, orderByChild, equalTo, get } from 'firebase/database';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../../AuthContext';

const LoginFormUser = ({ history }) => {
    const { login } = useAuth();
    const auth = getAuth();
    const database = getDatabase();

    const [user, setUser] = useState({ loginId: '', Password: '' });
    const [loginMethod, setLoginMethod] = useState('mobile');
    const [loading, setLoading] = useState(false);

    // ── Forgot Password state ──────────────────────────────────────────
    const [showForgot, setShowForgot] = useState(false);
    const [forgotId, setForgotId] = useState('');
    const [forgotMethod, setForgotMethod] = useState('mobile');
    const [forgotFocused, setForgotFocused] = useState(false);
    const [forgotLoading, setForgotLoading] = useState(false);
    const [forgotSent, setForgotSent] = useState(false);

    // ── Reset-completion state (when user arrives via the emailed link) ─
    const [resetMode, setResetMode] = useState(false);
    const [resetCode, setResetCode] = useState(null);
    const [resetEmail, setResetEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [resetVerifying, setResetVerifying] = useState(true);
    const [resetSubmitting, setResetSubmitting] = useState(false);
    const [resetError, setResetError] = useState('');
    const [resetDone, setResetDone] = useState(false);

    // Detect ?mode=resetPassword&oobCode=... on page load
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const mode = params.get('mode');
        const oobCode = params.get('oobCode');

        if (mode === 'resetPassword' && oobCode) {
            setResetMode(true);
            verifyPasswordResetCode(auth, oobCode)
                .then((email) => {
                    setResetCode(oobCode);
                    setResetEmail(email);
                    setResetVerifying(false);
                })
                .catch(() => {
                    setResetError('This reset link is invalid or has expired. Please request a new one.');
                    setResetVerifying(false);
                });
        } else {
            setResetVerifying(false);
        }
    }, []);

    const handleRegisterClick = () => history.push('/register');

    const getData = (e) => {
        const { value, name } = e.target;
        setUser(prev => ({ ...prev, [name]: value }));
    };

    const toggleLoginMethod = () => {
        setLoginMethod(prev => prev === 'mobile' ? 'email' : 'mobile');
        setUser(prev => ({ ...prev, loginId: '' }));
    };

    const addData = async (e) => {
        e.preventDefault();
        const { loginId, Password } = user;

        if (!loginId) {
            toast.error(loginMethod === 'mobile' ? 'Mobile number is required' : 'Email is required');
            return;
        }
        if (loginMethod === 'mobile') {
            if (!/^\d{10}$/.test(loginId)) { toast.error('Please enter a valid 10-digit mobile number'); return; }
        } else {
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(loginId)) { toast.error('Please enter a valid email address'); return; }
        }
        if (!Password) { toast.error('Password is required'); return; }

        setLoading(true);
        try {
            let emailToLogin = loginId;
            let foundUserRole = '';

            if (loginMethod === 'mobile') {
                const collections = ['users', 'doctor', 'hospitals'];
                let foundUserData = null;
                let foundUserId = null;

                for (const collection of collections) {
                    const collectionRef = ref(database, collection);
                    const queryRef = query(collectionRef, orderByChild('Mobile'), equalTo(loginId));
                    const snapshot = await get(queryRef);
                    if (snapshot.exists()) {
                        const data = snapshot.val();
                        foundUserId = Object.keys(data)[0];
                        foundUserData = data[foundUserId];
                        if (foundUserData?.Email) {
                            emailToLogin = foundUserData.Email;
                            foundUserRole = collection === 'users' ? 'patient' : collection === 'doctor' ? 'doctor' : 'hospital';
                            break;
                        }
                    }
                }
                if (!foundUserData) { toast.error('No account found with this mobile number'); setLoading(false); return; }
            }

            const userCredential = await signInWithEmailAndPassword(auth, emailToLogin, Password);
            const userId = userCredential.user.uid;

            const collections = ['users', 'doctor', 'hospitals'];
            let userData = null;
            let userRole = '';

            for (const collection of collections) {
                const userRef = ref(database, `${collection}/${userId}`);
                const snapshot = await get(userRef);
                if (snapshot.exists()) {
                    userData = snapshot.val();
                    userRole = collection === 'users' ? 'patient' : collection === 'doctor' ? 'doctor' : 'hospital';
                    break;
                }
            }

            if (userData) {
                let userName = '';
                if (userRole === 'patient') userName = `${userData.First || ''} ${userData.Last || ''}`.trim();
                else if (userRole === 'doctor') userName = `Dr. ${userData.First || ''} ${userData.Last || ''}`.trim();
                else if (userRole === 'hospital') userName = userData.HospitalName || 'Hospital User';
                else userName = userData.Email || 'User';

                login(userId, userRole, userName, userData.Email || emailToLogin, userData.Mobile || '');
                toast.success(`Welcome back, ${userName}!`);

                setTimeout(() => {
                    if (userRole === 'patient') history.push(`/AppointmentCheck/${userId}`);
                    else history.push('/');
                }, 1500);
            } else {
                toast.error('User data not found. Please contact support.');
            }
        } catch (error) {
            console.error('Login error:', error);
            if (error.code === 'auth/invalid-credential') toast.error('Invalid credentials. Please check your login ID and password.');
            else if (error.code === 'auth/user-not-found') toast.error('No account found. Please register first.');
            else if (error.code === 'auth/wrong-password') toast.error('Incorrect password. Please try again.');
            else if (error.code === 'auth/too-many-requests') toast.error('Too many failed attempts. Please try again later.');
            else if (error.code === 'auth/invalid-email') toast.error('Invalid email format.');
            else toast.error('Login failed: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // ── Forgot Password handler ────────────────────────────────────────
    const handleForgotPassword = async (e) => {
        e.preventDefault();

        if (!forgotId) {
            toast.error(forgotMethod === 'mobile' ? 'Please enter your registered mobile number' : 'Please enter your registered email');
            return;
        }
        if (forgotMethod === 'mobile' && !/^\d{10}$/.test(forgotId)) {
            toast.error('Invalid Mobile number'); return;
        }
        if (forgotMethod === 'email' && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(forgotId)) {
            toast.error('Invalid email address'); return;
        }

        setForgotLoading(true);
        try {
            let emailToReset = forgotId;

            if (forgotMethod === 'mobile') {
                const collections = ['users', 'doctor', 'hospitals'];
                let foundEmail = null;

                for (const collection of collections) {
                    const collectionRef = ref(database, collection);
                    const queryRef = query(collectionRef, orderByChild('Mobile'), equalTo(forgotId));
                    const snapshot = await get(queryRef);
                    if (snapshot.exists()) {
                        const data = snapshot.val();
                        const userId = Object.keys(data)[0];
                        if (data[userId]?.Email) { foundEmail = data[userId].Email; break; }
                    }
                }

                if (foundEmail) {
                    emailToReset = foundEmail;
                    const actionCodeSettings = {
                        url: `${window.location.origin}/login`,
                        handleCodeInApp: false,
                    };
                    await sendPasswordResetEmail(auth, emailToReset, actionCodeSettings);
                }
            } else {
                const actionCodeSettings = {
                    url: `${window.location.origin}/login`,
                    handleCodeInApp: false,
                };
                await sendPasswordResetEmail(auth, emailToReset, actionCodeSettings);
            }

            setForgotSent(true);
            toast.success('If that account exists, a reset link has been sent.');
        } catch (error) {
            console.error(error);
            setForgotSent(true);
            toast.success('If that account exists, a reset link has been sent.');
        } finally {
            setForgotLoading(false);
        }
    };

    // ── Reset-completion handler ───────────────────────────────────────
    const handleResetSubmit = async (e) => {
        e.preventDefault();
        if (!newPassword || !confirmNewPassword) { toast.error('Please fill in both password fields'); return; }
        if (newPassword.length < 6) { toast.error('Password must be at least 6 characters'); return; }
        if (newPassword !== confirmNewPassword) { toast.error('Passwords do not match'); return; }

        setResetSubmitting(true);
        try {
            await confirmPasswordReset(auth, resetCode, newPassword);
            setResetDone(true);
            toast.success('Password reset successfully! You can now log in.');
        } catch (error) {
            console.error(error);
            toast.error('Failed to reset password. The link may have expired.');
        } finally {
            setResetSubmitting(false);
        }
    };

    const openForgot = () => { setShowForgot(true); setForgotSent(false); setForgotId(''); };
    const closeForgot = () => { setShowForgot(false); setForgotSent(false); setForgotId(''); };

    // ── If arrived via reset email link, show reset form ──────────────
    if (resetMode) {
        return (
            <div className='container-fluid d-flex align-items-center justify-content-center' style={{ minHeight: '100vh', background: '#f0f9ff' }}>
                <ToastContainer />
                <div style={{ width: '100%', maxWidth: '420px', background: '#fff', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '40px 32px' }}>
                    <h2 className='text-center text-primary mb-1'>Reset Password</h2>
                    <p className='text-center text-muted mb-4' style={{ fontSize: 13 }}>TrustYou Doctor</p>

                    {resetVerifying ? (
                        <p className='text-center text-muted'>Verifying your reset link…</p>
                    ) : resetError ? (
                        <>
                            <p className='text-center text-danger mb-4'>{resetError}</p>
                            <Button variant='outline-primary' className='w-100' onClick={() => history.push('/login')}>Back to Login</Button>
                        </>
                    ) : resetDone ? (
                        <div className='text-center'>
                            <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M5 13l4 4L19 7" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <p className='text-muted mb-4'>Your password has been reset successfully. You can now log in with your new password.</p>
                            <Button variant='outline-primary' className='w-100' onClick={() => history.push('/login')}>Go to Login</Button>
                        </div>
                    ) : (
                        <Form onSubmit={handleResetSubmit}>
                            <p className='text-center text-muted mb-3' style={{ fontSize: 13 }}>
                                Resetting password for <strong>{resetEmail}</strong>
                            </p>
                            <Form.Group className='mb-3'>
                                <Form.Label>New Password</Form.Label>
                                <Form.Control type='password' placeholder='Enter new password' value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control type='password' placeholder='Confirm new password' value={confirmNewPassword} onChange={e => setConfirmNewPassword(e.target.value)} />
                            </Form.Group>
                            <Button variant='primary' type='submit' className='w-100' disabled={resetSubmitting}>
                                {resetSubmitting ? 'Resetting…' : 'Reset Password'}
                            </Button>
                        </Form>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className='container-fluid'>
            <ToastContainer />
            <div className='row'>
                <div className='col-md-12 col-xl-6 col-xxl-6 col-sm-12'>
                    <div className='container w-75 d-flex align-items-center justify-content-center'>
                        <div className='text-primary'>
                            <h2 className='text-center' style={{ marginTop: '10vh' }}>Welcome to TrustYou Doctor</h2>
                            <p className='mt-0 pt-0 text-center' color='#135078'>
                                Log in to manage appointments, access medical records, and stay connected with your healthcare journey.
                            </p>
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-center'>
                        <Form style={{ width: '70%', padding: '3vh' }}>
                            <div className='mb-3'>
                                <div className='btn-group w-100' role='group'>
                                    <button type='button' className={`btn ${loginMethod === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setLoginMethod('mobile')}>Mobile Login</button>
                                    <button type='button' className={`btn ${loginMethod === 'email' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setLoginMethod('email')}>Email Login</button>
                                </div>
                            </div>

                            <Form.Group className='mb-3'>
                                <Form.Label>{loginMethod === 'mobile' ? 'Mobile Number' : 'Email Address'}</Form.Label>
                                <Form.Control
                                    type={loginMethod === 'mobile' ? 'tel' : 'email'}
                                    placeholder={loginMethod === 'mobile' ? 'Enter 10-digit mobile number' : 'Enter your email address'}
                                    onChange={getData} name='loginId' value={user.loginId}
                                    className='input-background-color' disabled={loading}
                                />
                                <Form.Text className='text-muted'>
                                    {loginMethod === 'mobile' ? 'Enter your registered mobile number' : 'Enter your registered email address'}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group className='mb-3'>
                                <Form.Label>Password</Form.Label>
                                <Form.Control type='password' placeholder='Enter your password' onChange={getData} name='Password' value={user.Password} className='input-background-color' disabled={loading} />
                            </Form.Group>

                            <Form.Group className='mb-3 text-end'>
                                <Form.Label onClick={openForgot} style={{ cursor: 'pointer', color: '#0d6efd' }}>
                                    Forgot Password?
                                </Form.Label>
                            </Form.Group>

                            <div className='mb-3'>
                                <Button className='btn btn-primary w-100' onClick={addData} variant='primary' type='submit' disabled={loading}>
                                    {loading ? 'Logging in...' : 'Login'}
                                </Button>
                            </div>

                            <div className='text-center'>
                                <p className='mb-2'>
                                    {loginMethod === 'mobile' ? 'Prefer to login with email?' : 'Prefer to login with mobile?'}
                                    <button type='button' onClick={toggleLoginMethod} style={{ border: 'none', background: 'none', color: '#2563EB', marginLeft: '5px', textDecoration: 'underline' }}>Click here</button>
                                </p>
                                <button style={{ border: 'none', background: 'white', color: '#2563EB', fontSize: '16px' }} onClick={handleRegisterClick}>
                                    Don't have an Account? <strong>Register Now</strong>
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>

                <div className='col-md-12 col-xl-6 col-xxl-6 col-sm-12'>
                    <img src={UserLoginImg} alt='User Login' style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover', minHeight: '100vh' }} />
                </div>
            </div>

            {/* ── Forgot Password Modal ──────────────────────────────────── */}
            {showForgot && (
                <div
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(12,74,110,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1000 }}
                    onMouseDown={closeForgot}
                >
                    <div
                        style={{ width: '100%', maxWidth: '400px', background: '#fff', borderRadius: '16px', boxShadow: '0 12px 48px rgba(14,116,144,0.25)', padding: '30px 26px 26px' }}
                        onMouseDown={e => e.stopPropagation()}
                    >
                        {!forgotSent ? (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                                    <h5 style={{ margin: 0, color: '#0c4a6e', fontWeight: 700 }}>Reset Password</h5>
                                    <button onClick={closeForgot} style={{ background: '#f0f9ff', border: 'none', borderRadius: '8px', width: 30, height: 30, cursor: 'pointer', color: '#0369a1', fontSize: 16 }}>✕</button>
                                </div>

                                {/* Toggle mobile/email for forgot */}
                                <div className='btn-group w-100 mb-3' role='group'>
                                    <button type='button' className={`btn btn-sm ${forgotMethod === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setForgotMethod('mobile'); setForgotId(''); }}>Mobile</button>
                                    <button type='button' className={`btn btn-sm ${forgotMethod === 'email' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setForgotMethod('email'); setForgotId(''); }}>Email</button>
                                </div>

                                <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
                                    {forgotMethod === 'mobile'
                                        ? "Enter your registered mobile number. We'll send a reset link to the linked email."
                                        : "Enter your registered email address and we'll send a reset link."}
                                </p>

                                <Form onSubmit={handleForgotPassword}>
                                    <Form.Group className='mb-3'>
                                        <Form.Label style={{ fontSize: 13, fontWeight: 600, color: '#0369a1' }}>
                                            {forgotMethod === 'mobile' ? 'Mobile Number' : 'Email Address'}
                                        </Form.Label>
                                        <Form.Control
                                            type={forgotMethod === 'mobile' ? 'tel' : 'email'}
                                            placeholder={forgotMethod === 'mobile' ? '10-digit mobile number' : 'your@email.com'}
                                            value={forgotId}
                                            onChange={e => setForgotId(e.target.value)}
                                            maxLength={forgotMethod === 'mobile' ? 10 : undefined}
                                            autoFocus
                                        />
                                    </Form.Group>
                                    <Button variant='primary' type='submit' className='w-100' disabled={forgotLoading}>
                                        {forgotLoading ? 'Sending…' : 'Send Reset Link'}
                                    </Button>
                                </Form>
                            </>
                        ) : (
                            <div className='text-center py-2'>
                                <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                        <path d="M5 13l4 4L19 7" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h5 style={{ color: '#0c4a6e', fontWeight: 700, marginBottom: 10 }}>Check Your Email</h5>
                                <p style={{ fontSize: 14, color: '#334155', marginBottom: 20 }}>
                                    If that account is registered, a password reset link has been sent. Open it to set a new password, then come back to log in.
                                </p>
                                <Button variant='outline-primary' className='w-100' onClick={closeForgot}>Done</Button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default withRouter(LoginFormUser);